import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { MediaQuery, LoaderScreen, Alert } from '@grandvisionhq/common';
import { ConfiguratorStepTitleAndDescription } from '@grandvisionhq/configurator';
import { useIntl } from '@grandvisionhq/state';
import { RxStepWrapper } from '../RxStepWrapper/RxStepWrapper.js';
import DesktopStepLayout from '../DesktopStepLayout/DesktopStepLayout.js';

var StepWithAlerts = (_param)=>{
    var { children , alertLabel , className , errorMessage , errorMessageId , isLoading , isFailed  } = _param; swcHelpers.objectWithoutProperties(_param, [
        "children",
        "alertLabel",
        "className",
        "errorMessage",
        "errorMessageId",
        "isLoading",
        "isFailed"
    ]);
    const { getLabel  } = useIntl();
    const alertRef = React.useRef(null);
    const isDesktop = MediaQuery.useIsDesktop();
    React.useEffect(()=>{
        if ('scrollBehavior' in document.documentElement.style) {
            var ref;
            (ref = alertRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        } else {
            var ref1;
            (ref1 = alertRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView();
        }
    }, [
        errorMessage
    ]);
    if (isLoading) {
        return /*#__PURE__*/ React.createElement(LoaderScreen, null);
    }
    if (isFailed) {
        return /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            title: getLabel('products.glasses.configurator.error'),
            className: "step-with-alerts__alert"
        });
    }
    return /*#__PURE__*/ React.createElement(RxStepWrapper, {
        className: classnames('step-with-alerts', className)
    }, /*#__PURE__*/ React.createElement(DesktopStepLayout, null, /*#__PURE__*/ React.createElement("div", {
        className: "step-with-alerts__wrapper"
    }, /*#__PURE__*/ React.createElement(ConfiguratorStepTitleAndDescription, {
        textAlignment: isDesktop ? 'left' : 'center'
    }), alertLabel && /*#__PURE__*/ React.createElement(Alert, {
        type: "info",
        icon: "information-circle",
        title: alertLabel,
        className: "step-with-alerts__alert"
    }), errorMessage && /*#__PURE__*/ React.createElement("div", {
        ref: alertRef
    }, /*#__PURE__*/ React.createElement(Alert, {
        id: errorMessageId,
        type: "error",
        icon: "alert-circle",
        title: errorMessage,
        className: "step-with-alerts__alert",
        notifyScreenReader: true
    })), children)));
};

export { StepWithAlerts };
//# sourceMappingURL=StepWithAlerts.js.map
